<div class="video-widget-overlay" *ngIf="isVisible">
  <!-- Blocks media from stealing pointer events while dragging or resizing -->
  <div
    *ngIf="isInteracting"
    class="interaction-shield"
    [style.cursor]="interactionCursor"
  ></div>

  <div
    class="video-widget-container"
    [class.resizing]="resizingActive"
    [class.dragging]="draggingActive"
    [class.interacting]="isInteracting"
    [class.external-webpage]="isExternalWebPage"
    [style.width.px]="widgetWidth"
    [style.height.px]="widgetHeight"
    [style.left.px]="widgetX"
    [style.top.px]="widgetY"
  >
    <div class="video-widget-header" (pointerdown)="startDrag($event)">
      <div class="widget-controls">
        <ng-container
          *ngIf="isStream && !isExternalWebPage && streamEngineServerUrl"
        >
          <button
            type="button"
            class="control-btn"
            (click)="toggleMuted($event)"
            [title]="
              (playerUi.muted ? 'VIDEO_CONTROL.UNMUTE' : 'VIDEO_CONTROL.MUTE')
                | translate
            "
          >
            <i
              class="fa"
              [class.fa-volume-off]="playerUi.muted"
              [class.fa-volume-up]="!playerUi.muted"
              aria-hidden="true"
            ></i>
          </button>
          <button
            type="button"
            class="control-btn"
            (click)="toggleObjectFit($event)"
            [title]="
              (playerUi.objectFit === 'fill'
                ? 'VIDEO_CONTROL.FIT_CONTAIN'
                : 'VIDEO_CONTROL.FIT_FILL'
              ) | translate
            "
          >
            <i
              class="fa"
              [class.fa-compress]="playerUi.objectFit === 'fill'"
              [class.fa-expand]="playerUi.objectFit === 'contain'"
              aria-hidden="true"
            ></i>
          </button>
        </ng-container>
        <ng-container *ngIf="hasMedia">
          <button
            type="button"
            class="control-btn"
            (click)="zoomOut($event)"
            [disabled]="!zoomCtrl.canZoomOut"
            [title]="'VIDEO_CONTROL.ZOOM_OUT' | translate"
          >
            <i class="fa fa-search-minus" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            class="control-btn zoom-label"
            (click)="resetZoom($event)"
            [title]="'VIDEO_CONTROL.ZOOM_RESET' | translate"
          >
            {{ zoomCtrl.percentLabel }}
          </button>
          <button
            type="button"
            class="control-btn"
            (click)="zoomIn($event)"
            [disabled]="!zoomCtrl.canZoomIn"
            [title]="'VIDEO_CONTROL.ZOOM_IN' | translate"
          >
            <i class="fa fa-search-plus" aria-hidden="true"></i>
          </button>
        </ng-container>
        <button
          class="control-btn minimize-btn"
          (click)="minimizeWidget()"
          title="Minimize"
        >
          <i class="fa fa-minus"></i>
        </button>
        <button
          class="control-btn maximize-btn"
          (click)="maximizeWidget()"
          title="Maximize/Restore"
        >
          <i class="fa fa-expand"></i>
        </button>
        <button
          class="control-btn close-btn"
          (click)="closeVideo()"
          title="Close"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>

    <div class="video-widget-content" (wheel)="onMediaWheel($event)">
      <ng-container *ngIf="hasMedia; else noMedia">
        <div
          #zoomViewport
          class="media-zoom-viewport"
          [class.is-zoomed]="zoomCtrl.isZoomed"
          [class.is-panning]="zoomCtrl.isPanning"
        >
          <div
            class="media-zoom-layer"
            [class.no-transition]="zoomCtrl.isPanning"
            [style.transform]="zoomCtrl.transform"
          >
            <iframe
              *ngIf="isStream && isExternalWebPage"
              class="stream-player"
              width="100%"
              height="100%"
              frameBorder="0"
              [src]="mediaUrl | safe"
              scrolling="auto"
            >
            </iframe>

            <rse-player
              *ngIf="isStream && !isExternalWebPage && streamEngineServerUrl"
              class="stream-player"
              [serverUrl]="streamEngineServerUrl"
              [url]="mediaUrl"
              [appToken]="streamAppToken"
              [muted]="playerUi.muted"
              [objectFit]="playerUi.objectFit"
            ></rse-player>

            <video
              *ngIf="isVideo"
              class="fullscreen-video"
              controls
              autoplay
              loop
              playsinline
            >
              <source [src]="mediaUrl" type="video/mp4" />
              Your browser does not support HTML5 video.
            </video>

            <img
              *ngIf="isPhoto"
              class="fullscreen-photo"
              [src]="mediaUrl"
              alt="Alarm media"
            />
          </div>
          <!-- Captures drag when zoomed so iframe/video don't steal pointer events -->
          <div
            *ngIf="zoomCtrl.isZoomed"
            class="media-pan-surface"
            (pointerdown)="startPan($event)"
          ></div>
        </div>
      </ng-container>

      <ng-template #noMedia>
        <div class="media-empty-state">No media available.</div>
      </ng-template>
    </div>

    <div
      class="resize-handle resize-n"
      (pointerdown)="startResize($event, 'n')"
    ></div>
    <div
      class="resize-handle resize-s"
      (pointerdown)="startResize($event, 's')"
    ></div>
    <div
      class="resize-handle resize-e"
      (pointerdown)="startResize($event, 'e')"
    ></div>
    <div
      class="resize-handle resize-w"
      (pointerdown)="startResize($event, 'w')"
    ></div>
    <div
      class="resize-handle resize-ne"
      (pointerdown)="startResize($event, 'ne')"
    ></div>
    <div
      class="resize-handle resize-nw"
      (pointerdown)="startResize($event, 'nw')"
    ></div>
    <div
      class="resize-handle resize-se"
      (pointerdown)="startResize($event, 'se')"
    ></div>
    <div
      class="resize-handle resize-sw"
      (pointerdown)="startResize($event, 'sw')"
    ></div>
  </div>
</div>
